export const JOBTEASER_SESSION_COOKIE_NAME = "jobteaser_session"
export const VISITOR_ID_COOKIE_NAME = "visitor_id"
export const VISITOR_ID_HEADER = "x-visitor-id"
